class OctoberFooter extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.media = matchMedia('(min-width: 750px)');
    const menus = [...this.querySelectorAll('[data-od-footer-menu]')];
    const fixedOpen = () => this.media.matches || this.dataset.accordions === 'false';
    const sync = () => menus.forEach(menu => {
      menu.open = fixedOpen() || menu.dataset.openMobile === 'true';
      menu.querySelector('summary').tabIndex = fixedOpen() ? -1 : 0;
    });
    this.media.addEventListener('change', sync, { signal });
    menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
      if (fixedOpen()) event.preventDefault();
    }, { signal }));
    document.addEventListener('shopify:block:select', event => {
      if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
      const menu = menus.find(item => item.dataset.blockId === event.detail?.blockId);
      if (menu) menu.open = true;
    }, { signal });
    sync();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('od-footer')) customElements.define('od-footer', OctoberFooter);
